<template>
    <div class="supply-hall">
        <div class="container">
            <!-- 左侧分类导航 -->
            <div class="category-sidebar">
                <div class="category-item" v-for="(category, index) in categories" :key="category.aid"
                    :class="{ active: selectedCategory === category.aid }" @click="selectCategory(category.aid, index)">
                    {{ category.name }}
                </div>
            </div>

            <!-- 右侧商品内容 -->
            <div class="product-content">
                <!-- 顶部大标题 -->
                <div class="content-title">
                    {{ currentCategory ? currentCategory.name : '商品分类' }}
                </div>

                <!-- 子分类导航 - 按二级分组展示三级 goods，默认三行，超出可展开 -->
                <div class="sub-category-nav" v-if="currentCategory && currentCategory.children && currentCategory.children.length">
                    <div class="sub-category-group" v-for="(group, groupIndex) in currentCategory.children" :key="groupIndex">
                        <div class="group-title-row">
                            <div class="group-title">{{ group.name }}</div>
                            <span class="group-more" v-if="groupOverflow[groupIndex]"
                                :class="{ 'is-expanded': expandedGroups[groupIndex] }"
                                @click="toggleGroup(groupIndex)">
                                {{ expandedGroups[groupIndex] ? '收起' : '更多' }}
                                <i class="el-icon-arrow-down"></i>
                            </span>
                        </div>
                        <div class="group-items" :class="{ collapsed: !expandedGroups[groupIndex] }"
                            v-if="group.goods && group.goods.length">
                            <div class="sub-category-item"
                                v-for="(goods, goodsIndex) in group.goods" :key="goodsIndex"
                                :class="{ active: selectedGoods === goods.aid }"
                                @click.stop="selectThirdGoods(group.aid, goods)">
                                {{ goods.name }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 行情更新时间 -->
                <div class="market-update-time">
                    行情更新时间：{{ update_time }}
                </div>

                <!-- 市场行情表格 (使用Element UI的el-table) -->
                <div class="market-table-container">
                    <el-table :data="marketData" stripe style="width: 100%" @row-click="handleRowClick">
                        <el-table-column prop="name" label="商品" min-width="120"></el-table-column>
                        <el-table-column prop="yesterday_price" label="昨日平均单价" min-width="150">
                            <template slot-scope="scope">
                                <span>
                                    {{ scope.row.yesterday_price }}/{{ scope.row.unit }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="price" label="今日平均单价" min-width="150">
                            <template slot-scope="scope">
                                <span>
                                    {{ scope.row.price }}/{{ scope.row.unit }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="is_up" label="升/降" min-width="100">
                            <template slot-scope="scope">
                                <span :class="{
                                    'price-down': scope.row.is_up == 1,
                                    'price-stable': scope.row.is_up == 2,
                                    'price-up': scope.row.is_up == 3
                                }">
                                    {{ scope.row.is_up == 1 ? '降' : scope.row.is_up == 2 ? '平稳' : '升' }}
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Market', // 修正组件名称
    data() {
        return {
            selectedCategory: 0, // 当前选中的分类ID
            selectedCategoryIndex: 0, // 当前选中的分类索引
            selectedSubCategory: '', // 当前选中的二级分类ID
            selectedGoods: '', // 当前选中的三级 goods aid
            categories: [], // 分类数据将从接口获取
            marketData: [],
            keyword: '',
            update_time: '',

            expandedGroups: {}, // 展开状态：key 为二级分组索引
            groupOverflow: {},  // 三级是否超出三行
        }
    },
    computed: {
        // 添加当前选中分类的计算属性
        currentCategory() {
            // 优先通过索引查找
            const categoryByIndex = this.categories[this.selectedCategoryIndex];
            if (categoryByIndex && categoryByIndex.aid === this.selectedCategory) {
                return categoryByIndex;
            }

            // 如果索引查找失败，通过aid查找
            return this.categories.find(category => category.aid === this.selectedCategory) || null;
        },
          // 通过getter获取cityCode
        cityCode() {
            return this.$store.getters.getCityCode[1];
        }
    },
    mounted() {
        // 获取分类数据
        this.getHomeShopFenlei();
    },
    watch: {
        cityCode(newVal, oldVal) {
            this.getMarketList()
        }
    },
    methods: {
        // 展开/收起某个二级分组的三级列表
        toggleGroup(groupIndex) {
            this.$set(this.expandedGroups, groupIndex, !this.expandedGroups[groupIndex]);
        },

        // 三级超出 6 条则显示"更多/收起"
        checkOverflow() {
            const children = (this.currentCategory && this.currentCategory.children) || [];
            children.forEach((group, groupIndex) => {
                this.$set(this.groupOverflow, groupIndex, !!(group.goods && group.goods.length > 6));
            });
        },

        // 获取分类数据 - 直接使用SupplyHall的接口
        getHomeShopFenlei() {
            this.$api.getHomeShopFenlei().then(res => {
                let list = res;
                this.categories = list;
                if (list.length > 0) {
                    // 设置默认选中第一个分类
                    this.selectedCategory = list[0].aid;
                    this.selectedCategoryIndex = 0;

                    // 如果有子分类，默认选中第一个子分类
                    if (list[0].children && list[0].children.length > 0) {
                        this.selectedSubCategory = list[0].children[0].aid;
                    }
                    this.getMarketList()
                    this.checkOverflow();
                }
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 选择左侧一级分类
        selectCategory(aid, index) {
            this.selectedCategory = aid;
            this.selectedCategoryIndex = index;
            this.selectedGoods = '';
            this.keyword = '';

            // 默认选中第一个子分类
            if (this.categories[index].children && this.categories[index].children.length > 0) {
                this.selectedSubCategory = this.categories[index].children[0].aid;
            } else {
                this.selectedSubCategory = '';
            }
            this.getMarketList()
            // 切换分类时重置展开状态并重新检测行数
            this.expandedGroups = {};
            this.checkOverflow();
            // 这里可以添加加载对应分类商品的逻辑
            console.log('Selected category:', this.categories[index].name);
            // 可以在这里调用获取行情数据的接口
            // this.getMarketData();
        },

        // 选择二级分类
        selectSubCategory(aid) {
            this.selectedSubCategory = aid;
            this.selectedGoods = '';
            this.keyword = '';
            // 这里可以添加加载对应子分类商品的逻辑
            console.log('Selected sub-category:', aid);
            this.getMarketList()
            // 可以在这里调用获取行情数据的接口
            // this.getMarketData();
        },

        // 选择三级 goods：按所属二级 aid 过滤，并传关键词（goods 名称）给行情接口
        selectThirdGoods(groupAid, goods) {
            this.selectedSubCategory = groupAid;
            this.selectedGoods = goods.aid;
            this.keyword = goods.name;
            this.getMarketList();
        },

        // 获取行情列表
        getMarketList() {
            let data = {
                goodscategory_id: this.selectedSubCategory || this.selectedCategory,
                keyword: this.keyword,
                region_code: this.cityCode
            }
            this.$api.getMarketList(data).then(res => {
                this.marketData = res.list || [];
                this.category_name = res.category_name
                this.update_time = res.update_time
                console.log(this.marketData, 'this.marketData');

            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 处理行点击事件
        handleRowClick(row) {
            // 跳转到行情详情页，传递商品ID
            this.$router.push({
                name: 'MarketDetails',
                query: {
                    id: row.goodscategory_id
                }
            });
        }
    }
}
</script>

<style scoped>
/* 保持原有的样式不变 */
.supply-hall {
    background-color: #f5f5f5;
    min-height: calc(100vh - 120px);
    padding: 20px 0;
}

.container {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    gap: 20px;
}

/* 左侧分类导航 */
.category-sidebar {
    width: 120px;
    background-color: #ffffff;
    border-radius: 8px;
    padding: 15px 0;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.category-item {
    padding: 12px 20px;
    font-size: 14px;
    color: #333333;
    cursor: pointer;
    transition: all 0.3s;
    text-align: center;
}

.category-item:hover {
    color: #286CED;
    background-color: #f0f4ff;
}

.category-item.active {
    color: #ffffff;
    background-color: #286CED;
    font-weight: 500;
}

/* 右侧商品内容 */
.product-content {
    flex: 1;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    padding: 20px;
}

/* 内容标题 */
.content-title {
    display: flex;
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 20px;
}

/* 子分类导航 - 二级分组 + 三级平铺（与附近货源一致） */
.sub-category-nav {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 20px;
}

/* 子分类组（二级） */
.sub-category-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

/* 组标题行：标题 + 更多/收起 */
.group-title-row {
    display: flex;
    align-items: center;
    gap: 6px;
}

/* 组标题 */
.group-title {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    text-align: left;
}

.group-more {
    font-size: 12px;
    color: #286CED;
    cursor: pointer;
    white-space: nowrap;
    user-select: none;
    display: inline-flex;
    align-items: center;
    gap: 2px;
}

.group-more:hover {
    text-decoration: underline;
}

.group-more .el-icon-arrow-down {
    font-size: 12px;
    transition: transform 0.3s;
}

.group-more.is-expanded .el-icon-arrow-down {
    transform: rotate(180deg);
}

/* 组内子分类（三级 goods） */
.group-items {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 20px;
    font-size: 12px;
}

/* 默认收起：只展示前 6 条，第 7 条起隐藏 */
.group-items.collapsed .sub-category-item:nth-child(n+7) {
    display: none;
}

/* 子分类项：固定行高，保证三行高度可计算 */
.sub-category-item {
    font-size: 13px;
    color: #666666;
    line-height: 22px;
    padding: 0;
    cursor: pointer;
    transition: all 0.3s;
    white-space: nowrap;
}

.sub-category-item:hover {
    color: #286CED;
}

.sub-category-item.active {
    color: #286CED;
    font-weight: bold;
}

/* 行情更新时间 */
.market-update-time {
    color: #ff4757;
    font-size: 14px;
    margin-bottom: 15px;
    padding-left: 5px;
    text-align: left;
}

/* 市场行情表格容器 */
.market-table-container {
    background-color: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

/* 自定义Element UI表格样式 */
::v-deep .el-table {
    border-radius: 8px;
    overflow: hidden;
}

::v-deep .el-table__header-wrapper th {
    background-color: #fafafa;
    font-weight: bold;
    color: #333333;
    font-size: 14px;
    padding: 12px 20px;
}

::v-deep .el-table__body-wrapper td {
    color: #666666;
    font-size: 14px;
    padding: 12px 20px;
}

::v-deep .el-table__row:hover {
    background-color: #fafafa;
}

/* 价格变化样式 */
.price-up {
    color: #ff4757;
}

.price-down {
    color: #2ed573;
}

.price-stable {
    color: #999999;
}

/* 响应式设计 */
@media (max-width: 1200px) {
    .container {
        width: 100%;
        padding: 0 20px;
    }

    .sub-category-nav {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 768px) {
    .container {
        flex-direction: column;
    }

    .category-sidebar {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: 10px;
    }

    .category-item {
        flex: 1;
        min-width: 80px;
        padding: 10px 15px;
        display: flex;
    }

    .sub-category-nav {
        grid-template-columns: 1fr;
    }

    .sort-options {
        flex-wrap: wrap;
    }
}

@media (max-width: 576px) {
    .content-title {
        font-size: 20px;
    }

    .sort-options {
        gap: 10px;
    }

    .sort-item {
        font-size: 12px;
        padding: 4px 8px;
    }
}

.sort-item img {
    width: 6px;
    height: 9px;
}

.sort-item .xiala {
    width: 6px;
    height: 6px;
}
</style>